import { ALLOWED_IMAGE_EXTENSIONS } from "@/shared/constants"

export const getFileExtension = (file: Pick<File, "name">) =>
  file.name.split(".").pop()?.toLowerCase()

export const isSupportedImageFile = (file: Pick<File, "name" | "type">) => {
  const extension = getFileExtension(file)
  const hasImageType =
    file.type.startsWith("image/") ||
    file.type === "" ||
    file.type === "application/octet-stream"

  return Boolean(
    hasImageType && extension && ALLOWED_IMAGE_EXTENSIONS.includes(extension)
  )
}
